import { render, staticRenderFns } from "./FormattedTextInput.vue?vue&type=template&id=64bb9751&"
import script from "./FormattedTextInput.vue?vue&type=script&lang=js&"
export * from "./FormattedTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports